import { render } from "./PointsRecordList.vue?vue&type=template&id=a1d742d0&scoped=true"
import script from "./PointsRecordList.vue?vue&type=script&lang=js"
export * from "./PointsRecordList.vue?vue&type=script&lang=js"

import "./PointsRecordList.vue?vue&type=style&index=0&id=a1d742d0&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Student_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d742d0"]])

export default __exports__